import { useEffect, useState } from 'react'
import type { User } from '../../../utils/loginUtils'
import { getUsersList } from '../../../utils/usersUtils'
import UsersList from './UsersList'
import Spinner from '../../Spinner/Spinner'
import { getMessage } from '../../../utils/messageUtils'
import UserConfig from './UserConfig'

interface UsersProps {
  currentUser: User
  isMobile: boolean
}

function Users({ currentUser, isMobile }: UsersProps) {
  const [loadData, setLoadData] = useState<boolean>(true)
  const [users, setUsers] = useState<User[]>([])
  const [user, setUser] = useState<User | null>(null)

  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const fetchUserInfo = async () => {
      setLoadData(false)
      setIsLoading(true)
      try {
        const data = await getUsersList(currentUser.id!)
        if (data.success) {
          // Not admin
          if (data.user) {
            setUser(data.user)
          }
          // Admin
          if (data.users) {
            setUsers(data.users)
          }
        }
      } finally {
        setIsLoading(false)
      }
    }
    if (loadData) {
      fetchUserInfo()
    }
  }, [loadData, currentUser.id])

  const generateUsersContent = () => {
    if (user) {
      return (
        <UserConfig currentUser={currentUser} user={user} isMobile={isMobile} />
      )
    } else if (users.length > 0) {
      return (
        <UsersList
          currentUser={currentUser}
          users={users}
          isMobile={isMobile}
          setLoadData={setLoadData}
        />
      )
    }
  }

  return (
    <div className="users-tab">
      {generateUsersContent()}
      <Spinner
        isOpen={isLoading}
        overlay={true}
        message={getMessage('loading')}
      />
    </div>
  )
}

export default Users
